import React from 'react';

type TableData = {
  title?: string[];
  slNo?: string;
  firstColumn?: string[];
  secondColumn?: string[];
  thirdColumn?: string[];
  fourthColumn?: string[];
};

type MoreDetailsTableData = {
  domain: string;
  faculty?: string[];
  researchScholars?: string[];
  year?: string;
};

type ResearchData = {
  heading?: string;
  points?: string[];
  imageUrl?: string;
  table?: TableData[];
  moreDetailesTable?: MoreDetailsTableData[];
  th?: string[];
};

type ResearchProps = {
  data: ResearchData[];
  deptName?:string
};

const Research: React.FC<ResearchProps> = ({ data ,deptName}) => {
  return (
    <div className="text-textGray text-[17px]">
      {(data || []).map((section, idx) => {
        const hasData =
          section.heading ||
          (section.points?.length ?? 0) > 0 ||
          section.imageUrl ||
          (section.table &&
            section.table.some(
              (t) =>
                (t.firstColumn?.length ?? 0) > 0 ||
                (t.secondColumn?.length ?? 0) > 0 ||
                (t.thirdColumn?.length ?? 0) > 0 ||
                (t.fourthColumn?.length ?? 0) > 0
            )) ||
          (section.moreDetailesTable?.length ?? 0) > 0;

        if (!hasData) return null;

        return (
          <div key={idx} className="mb-8">
            {section.heading && (
              <h2 className="text-xl font-bold mb-2 text-textGray">
                {section.heading}
              </h2>
            )}

            {(section.points?.length ?? 0) > 0 && (
              <ul className="list-disc ml-6 mb-2 md:text-lg text-[14px] leading-7 text-textGray">
                {section.points?.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            )}

            {section.imageUrl && (
              <img
                src={section.imageUrl}
                alt={section.heading || 'Image'}
                className="my-4 max-w-full rounded"
              />
            )}

            {section.table?.map((table, tIdx) => {
              const columns = [
                table.firstColumn || [],
                table.secondColumn || [],
                table.thirdColumn || [],
                table.fourthColumn || [],
              ].filter((col) => col.length > 0).length;

              if (columns === 0) return null;

              const maxRows = Math.max(
                table.firstColumn?.length ?? 0,
                table.secondColumn?.length ?? 0,
                table.thirdColumn?.length ?? 0,
                table.fourthColumn?.length ?? 0
              );

              const showSlNo = !!table.slNo;
              const showHeader =
                Array.isArray(table.title) && (table.title?.length ?? 0) > 0;

              return (
                <div
                  key={tIdx}
                  className="rounded overflow-x-auto border border-gray-200 w-full"
                >
                  <table className="w-full text-left border border-gray-200 text-[13px] md:text-[15px]">
                    {showHeader && (
                      <thead>
                        <tr className="bg-[#F3F8FC] text-[#2884CA]">
                          {showSlNo && (
                            <th className="py-3 md:px-4 px-1 border-b">Sl.No</th>
                          )}
                          {table.title
                            ?.slice(0, columns + (showSlNo ? 1 : 0))
                            .map((title, i) => (
                              <th
                                key={i}
                                className="py-3 md:px-4 px-1 border-b"
                              >
                                {title}
                              </th>
                            ))}
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {Array.from({ length: maxRows }).map((_, rowIdx) => (
                        <tr key={rowIdx} className="text-textGray">
                          {showSlNo && (
                            <td className="py-3 md:px-4 px-1 border-b">
                              {rowIdx + 1}
                            </td>
                          )}
                          <td className="py-3 md:px-4 px-1 border-b">
                            {table.firstColumn?.[rowIdx] ?? ''}
                          </td>
                          <td className="py-3 md:px-4 px-1 border-b">
                            {table.secondColumn?.[rowIdx] ?? ''}
                          </td>
                          <td className="py-3 md:px-4 px-1 border-b">
                            {table.thirdColumn?.[rowIdx] ?? ''}
                          </td>
                          <td className="py-3 md:px-4 px-1 border-b">
                            {table.fourthColumn?.[rowIdx] ?? ''}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            })}

            {(section.moreDetailesTable?.length ?? 0) > 0 && (
              <div className="rounded overflow-hidden border border-gray-200 w-full">
                <table className="w-full text-left border border-gray-200 text-[13px] md:text-[15px]">
                  <thead>
                    <tr className="bg-[#F3F8FC] text-[#2884CA]">
                      {section.th?.map((item, idx) => (
                        <th
                          key={idx}
                          className="py-3 md:px-4 px-1 border-b"
                        >
                          {item}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {section.moreDetailesTable?.map((row, i) => (
                      <tr key={i} className="text-textGray">
                        {row.year && (
                          <td className="py-3 md:px-4 px-1 border-b">
                            {row.year}
                          </td>
                        )}
                        <td className="py-3 md:px-4 px-1 border-b">
                          {row.domain}
                        </td>
                        <td className="py-3 md:px-4 px-1 border-b">
                          {(row.faculty || []).join(', ')}
                        </td>
                   <td className="py-3 md:px-4 px-1 border-b whitespace-pre-line">
  {(row.researchScholars || [])
    .join(', ')
    .replace(/,\s*\n/g, '\n')}
</td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}

     {deptName==="Mechanical Engineering" && <a className='text-blue-600 hover:text-blue-800 underline' href="/departmentImages/JRF-APPLICATION.pdf" download>Download JRF Brochure & Application Form</a> }
    </div>
  );
};

export default Research;
